import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Offcanvas from "react-bootstrap/Offcanvas";
import RequestQuoteButton from "../../RequestButton/js/RequestQuoteButton";
import "../css/HeaderHome.css"; // Import the CSS file

const HeaderHome = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false); // State for off-canvas

  useEffect(() => {
    const headerHeight = document.querySelector("header").offsetHeight;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const stickyCondition = scrollTop > window.innerHeight - headerHeight;

      setIsSticky(stickyCondition);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setShowOffcanvas(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  return (
    <header className={isSticky ? "sticky" : ""}>
      <div className="logo">
      <Link className="nav-link" to="/">
        <img
          src="/images/Logos/SmallLogo.png"
          alt="Logo"
          className="HeaderLogoImage"
        />
        </Link>
      </div>
      <Navbar expand="lg">
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={toggleOffcanvas}
        />
        <nav className="navbar-collapse" id="basic-navbar-nav">
          <ul className="nav mr-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                HOME
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/portfolio">
                PORTFOLIO
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/services">
                SERVICES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/industries">
                INDUSTRIES
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                ABOUT
              </Link>
            </li>
          </ul>
        </nav>

        <Offcanvas
          show={showOffcanvas}
          onHide={toggleOffcanvas}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>ALPHA 1</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav.Link href="/">HOME</Nav.Link>
            <Nav.Link href="/portfolio">PORTFOLIO</Nav.Link>
            <Nav.Link href="/services">SERVICES</Nav.Link>
            <Nav.Link href="/industries">INDUSTRIES</Nav.Link>
            <Nav.Link href="/about">ABOUT</Nav.Link>
            <br />
            <RequestQuoteButton />
          </Offcanvas.Body>
        </Offcanvas>
      </Navbar>
      <div className="RequestButtonMobile">
        <RequestQuoteButton />
      </div>
    </header>
  );
};

export default HeaderHome;
